export default {
  // Shared with master builder
  selectedItem: null,
  draggedElement: null,
  currentGlobalConfig: {},
  isDragMode: false,
}
